module.exports = __webpack_public_path__ + "static/media/avatar_29.4db8173a.svg";